<template>
  <div style="display: inline;">
    <el-button size="mini" type="text" round @click="handleShow">
      <i class="el-icon-upload2"/>导入
    </el-button>
    <el-drawer title="导入保量数据" :visible.sync="show" :close-on-press-escape='false' :wrapper-closable='false'
               :before-close="()=>{$emit('close');show=false;}"
               custom-class="live-guarantee-import-drawer default-table loading-dom">
      <el-steps :active="step" align-center>
        <el-step title="上传表格"/>
        <el-step title="校验数据"/>
        <el-step title="导入结束"/>
      </el-steps>
      <div class="el-drawer__body-inner">
        <div style="text-align: center;"
             :style="`${(collection.length)&&!success?'height:100%;overflow-y: hidden;':''}`">
          <template v-if="step===STEP_0">
            <el-upload
                :headers="header"
                :before-upload="beforeUpload"
                :http-request="uploadExcel"
                :show-file-list="false"
                accept=".xls,.xlsx"
                class="upload-record" drag
                action="/api/live_guarantee/import">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">只能上传 xlsx / xls 文件，且不超过50M</div>
            </el-upload>
            <div style="height: 80px;"/>
            <el-link type="primary" icon="el-icon-download" @click="downTemplate">点击下载最新导入模板</el-link>
          </template>
          <template v-if="step===STEP_1">
            <import-table :list="collection" :total_settlement_amount="total_settlement_amount"
                          :total_commission_income="total_commission_income"/>
          </template>
          <template v-if="step===STEP_2">
            <import-table v-if="!errors.length" :list="collection" :total_settlement_amount="total_settlement_amount"
                          :total_commission_income="total_commission_income"/>
            <div v-else>
              <div style="text-align: center;margin-top: 70px;">
                <i class="el-icon-error" style="display: block;font-size: 60px;color: darkred;"/>
                <h3>导入失败</h3>
                <p>{{ tip }}</p>
                <el-link type="primary" icon="el-icon-download" @click="downTemplate">点击下载最新导入模板</el-link>
              </div>
              <ul class="ul-error" style="text-align: left;margin-top: 50px;color: darkred;">
                <li v-for="(error_row,error_row_index) in errors" :key="error_row_index">
                  {{ error_row.message }}
                  <br/>
                  <ul>
                    <li v-for="(item,error_column_index) in error_row.children" :key="'ec'+error_column_index">
                      {{ item }}
                    </li>
                  </ul>
                </li>
              </ul>
              <div style="height: 80px;"/>
            </div>
          </template>
          <template v-if="step===STEP_3">
            <div v-if="success">
              <div style="text-align: center;">
                <i class="el-icon-success" style="display: block;font-size: 60px;color: darkgreen;"/>
                <h2>导入成功</h2>
                <p>成功导入 <b style="font-size: 45px;">{{ result.import_count|numberFormat }}</b> 条数据！</p>
                <p>导入失败 <b style="font-size: 45px;margin-top: 10px;color: darkred;">{{
                    parseInt((result.rows_count - result.import_count) + '')
                  }}</b> 条数据！</p>
              </div>
              <div style="height: 80px;"/>
            </div>
            <div v-else style="text-align: center;">
              <i class="el-icon-error" style="display: block;font-size: 60px;color: darkred;"/>
              <h3>导入失败</h3>
              <p>{{ tip }}</p>
              <el-link type="primary" icon="el-icon-download" @click="downTemplate">点击下载最新导入模板</el-link>
            </div>
          </template>
        </div>
        <div class="footer">
          <template v-if="success">
            <el-button :disabled="loading" @click="handleCancel" size="medium">关闭</el-button>
          </template>
          <template v-else>
            <el-button :disabled="loading" @click="handleCancel" size="medium">取消</el-button>
            <button-submit :disabled="loading" v-if="step===STEP_1&&collection.length" size="medium"
                           button-txt="下一步，校验数据"
                           type="primary"
                           @click.native.prevent="handleValidate"/>
            <el-button :disabled="loading" v-if="errors.length&&step===STEP_2" size="medium" type="primary"
                       @click="handleReUpload">
              重新上传
            </el-button>
            <import-submit v-if="step===STEP_2&&!errors.length&&collection.length"
                           :list="collection" :file-name="file.name"
                           @end="callbackImportEnd"
                           style="margin-left: 10px;"/>
          </template>
        </div>
      </div>
    </el-drawer>
    <div v-if="step===STEP_0&&loading" class="mask">
      <div style="text-align: center;">
        <i class="el-icon-loading" style="font-size: 60px;color: #FFFFFF"/>
        <h2 style="color: #FFFFFF;text-align: center;">解析表格中...</h2>
        <h2 style="color: #FFFFFF;text-align: center;">请稍后</h2>
      </div>
    </div>
  </div>
</template>
<script>
import {Loading} from 'element-ui';
import {liveGuaranteeImportValidate} from "../../../../api/liveGuarantee";
import XLSX from "xlsx";
import ImportTable from "./import-table.vue";
import ImportSubmit from "./import-submit.vue";
import {BigNumber} from "bignumber.js";

let loadingInstance;

const map = {
  '佣金比例（%）': 'commission_rate',
  '商品名称': 'product_name',
  '平台': 'platform',
  '店铺名称': 'shop_name',
  '总佣金收入': 'commission_income',
  '月份': '_month',
  '流量来源': 'source_traffic',
  '结算金额': 'settlement_amount',
  '订单数': 'sales_volume',
  '达人昵称[以星广汇昵称为准]': 'artist_name',
  '达人账号': 'artist_no',
}

function getFieldLabel(value) {
  let label = ''
  for (const key in map) {
    if (map[key] === value) {
      label = key;
    }
  }
  return label
}

const STEP_0 = 0
const STEP_1 = 1
const STEP_2 = 2
const STEP_3 = 3
export default {
  name: 'LiveGuaranteeImport',
  components: {ImportSubmit, ImportTable},
  data() {
    return {
      show: false,
      STEP_0,
      STEP_1,
      STEP_2,
      STEP_3,
      step: STEP_0,
      collection: [],
      total_settlement_amount: 0,
      total_commission_income: 0,
      validate: {
        artist_names: [],
        platforms: [],
      },
      file: {},
      errors: [], // 异常
      loading: false,
      success: false,
      has_error: false,
      tip: 'EXCEL数据不规范，请仔细核对！',
      result: {
        rows_count: 0,
        import_count: 0,
        use_time: 0,
      }
    }
  },
  computed: {
    header() {
      return {
        Authorization: "Bearer " + this.getToken()
      }
    }
  },
  watch: {
    loading(_) {
      if (_) {
        let text = '加载中'
        switch (this.step) {
          case STEP_0:
            text = '解析表格中...'
            break;
          case STEP_1:
            text = '校验数据中...'
            break;
          case STEP_2:
            text = '上传数据...'
            break;
        }
        loadingInstance = Loading.service({
          target: '.loading-dom',
          fullscreen: true,
          text
        })
      } else {
        loadingInstance && loadingInstance.close()
      }
    }
  },
  methods: {
    handleShow: function () {
      this.show = true
      this.handleReUpload()
    },
    handleValidate: async function () {
      this.step = STEP_2
      if (this.errors.length) {
        this.tip = '数据不通过！'
        return;
      }
      this.loading = true
      const {success, model, message} = await liveGuaranteeImportValidate(this.validate)
      this.loading = false
      if (!success) {
        this.tip = message || '校验失败！'
        return;
      }
      this.errors = model || []
    },
    handleCancel: function () {
      this.$emit('close')
      this.show = false
    },
    downTemplate() {
      window.location.href = `/api/live_guarantee/import_template?token=${this.getToken()}`
    },
    handleReUpload: function () {
      this.step = STEP_0
      this.has_error = false
      this.success = false
      this.errors = []
      this.collection = []
      this.result = {
        rows_count: 0,
        import_count: 0,
        use_time: 0,
      }
    },
    beforeUpload(file) {
      this.loading = true
      const isLt2M = file.size / 1024 / 1024 < 50;
      if (!isLt2M) {
        this.$message.error("导入文件大小不能超过 50MB!");
        this.loading = false
      }
      return isLt2M;
    },
    uploadExcel: function ({file}) {
      if (!file) {
        return
      }
      this.file = file
      this.loading = true
      const reader = new FileReader()
      reader.onload = (e) => {
        const data = e.target.result
        const workbook = XLSX.read(data, {type: 'binary', codepage: 936})
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(worksheet);
        this.dealJson(json)
        setTimeout(() => {
          this.loading = false
        }, 100)
      }
      reader.readAsBinaryString(file)
    },
    dealJson: function (json) {
      this.loading = true
      const error_map = {}
      const required_fields = ['_month', 'platform', 'artist_name', 'source_traffic', 'shop_name', 'sales_volume', 'settlement_amount'];
      const collection = []
      let artist_names = []
      let platforms = []
      let total_settlement_amount = 0
      let total_commission_income = 0
      if (Array.isArray(json)) {
        json.map(_ => {
          let obj = {}
          for (const x in _) {
            obj[map[x]] = _[x]
          }
          required_fields.map(required_field => {
            const tmp_value = obj[required_field] || null
            if (tmp_value === '' || tmp_value === null) {
              if (error_map[required_field] === undefined) {
                error_map[required_field] = {
                  message: getFieldLabel(required_field) + '不能为空',
                  children: []
                }
              }
              error_map[required_field].children.push(`第${(_.__rowNum__ || 0) + 1}行`)
            }
          })
          obj.date_live = this.formatDate(obj._month)
          if (obj.commission_rate && typeof obj.commission_rate === 'string' && obj.commission_rate.indexOf('%')) {
            obj.commission_rate = BigNumber(obj.commission_rate.slice(0, -1)).toNumber()
          } else {
            obj.commission_rate = BigNumber(obj.commission_rate || 0).times(100).toNumber()
          }
          total_settlement_amount += parseFloat(obj.settlement_amount || 0)
          total_commission_income += parseFloat(obj.commission_income || 0)
          delete obj._month
          collection.push(obj)
          artist_names.push(obj.artist_name || '')
          platforms.push(obj.platform || '')
        })
      }
      this.errors = Object.values(error_map)
      this.validate.artist_names = Array.from(new Set(artist_names)).filter(_ => {
        return _
      });
      this.validate.platforms = Array.from(new Set(platforms)).filter(_ => {
        return _
      });

      // 到第二步骤
      this.collection = collection
      this.total_settlement_amount = total_settlement_amount
      this.total_commission_income = total_commission_income
      this.loading = false
      this.step = STEP_1
    },
    formatDate(numb) {
      if (!numb) {
        return '';
      }
      let year, month
      if (/^\d{4}年\d{2}月$/.test(numb)) {
        const tmp = numb.match(/\d+/g)
        year = tmp[0]
        month = tmp[1]
      } else {
        let time = new Date((numb - 1) * 24 * 3600000 + 1)
        time.setYear(time.getFullYear() - 70)
        year = time.getFullYear()
        month = time.getMonth() + 1
        month = month < 10 ? '0' + month : month
      }

      return `${year}-${month}-01`
    },
    callbackImportEnd: function ({success, model, message}) {
      this.step = STEP_3
      this.success = success
      if (!success) {
        this.has_error = true
        this.tip = message || '导入失败！'
        return;
      }
      this.result = model
    }
  }
}
</script>
<style lang="scss">
.live-guarantee-import-drawer {
  width: 1000px !important;

  .el-drawer__title {
    border-top-left-radius: 10px !important;
  }

  .el-drawer__header {
    font-size: 16px !important;
    color: #333333 !important;
    font-weight: 700;
    text-align: center;
  }

  .el-drawer__body {
    border-bottom-left-radius: 10px !important;
    padding: 0 40px 0 20px;

    &-inner {
      display: flex;
      align-items: center;
      justify-content: center;
      height: calc(100% - 62px);
    }
  }

  .footer {
    position: absolute;
    width: 100%;
    bottom: 0;
    right: 0;
    height: 66px;
    opacity: 1;
    background: #fff;
    box-shadow: 0 -3px 6px 0 rgba(0, 0, 0, .04), 0 2px 4px 0 rgba(0, 0, 0, .5);
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    z-index: 99;
  }

  .upload-record {
    text-align: center;
  }

  .el-table__row .cell {
    height: 16px !important;
    line-height: 16px !important;
  }

  .import-table.el-table {
    td, th {
      padding: 5px 0 !important;
    }
  }
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, .8); /*一般遮罩随便设置一个颜色*/
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
